export const iconFontAwesomeTransportationBus = (
	<i className="fa-solid fa-bus"></i>
);
